<template>
  <div
    class="relative flex items-center justify-center w-full overflow-hidden group sm:object-scale-down sm:object-center aspect-video sm:rounded-lg bg-slate-100 dark:bg-zinc-800"
  >
    <img class="absolute" src="/img/blurred-item.png" />
    <div class="relative z-10 flex flex-col items-center gap-4 dark:text-black">
      <div class="text-slate-400 bg-white p-2.5 rounded-full">
        <Icon :name="hiddenByReplyLimit ? 'general.lockKey' : 'general.eyeDisabled'" size="base" />
      </div>
      <template v-if="hiddenByReplyLimit">
        <h2 class="text-2xl font-bold">This content is temporarily unavailable</h2>
        <p class="text-center">The monthly reply limit has been reached.</p>
      </template>
      <template v-else-if="inactive">
        <h2 class="text-2xl font-bold">This content is no longer available</h2>
        <p class="text-center">The item owner's plan limit has been reached.</p>
      </template>
      <template v-else>
        <h2 class="text-2xl font-bold">This item has exceeded its view limit!</h2>
        <p class="text-center">The item owner has been notified that their item has exceeded its view limit.</p>
      </template>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { Icon } from '@/storybook/icon';
import { useViewerItemStore } from '../../store/useViewerItemStore';
import { storeToRefs } from 'pinia';

const viewerItemStore = useViewerItemStore();
const { inactive, hiddenByReplyLimit } = storeToRefs(viewerItemStore);
</script>
